/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum Modules {
    ScenarioDesigner = 1,
    Archive = 2,
    Export = 3,
    Checklists = 5,
    MediaScreens = 6,
    UserManagment = 7,
    DigitalSignature = 8,
    EventDesigner = 9,
    EnableRoomLayoutSwitcher = 10,
    AudioToRoom = 11,
    AudioOfPatient = 12,
    AudioToTrainer = 13,
    TrainTheTrainer = 14,
    EnergySaving = 15,
    Assessments = 16,
    Exam = 17,
    Monitoring = 18,
    PeerPractice = 19,
    MultiRoomRecording = 20,
    AutomaticRecording = 21,
}
